"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var PaymentVisaNetStyles_1 = require("./PaymentVisaNetStyles");
var SubaruLogo_png_1 = require("../../../../../../common/assets/images/SubaruLogo.png");
var BMWLogo_png_1 = require("../../../../../../common/assets/images/BMWLogo.png");
var PaymentProviderVisaNet_1 = require("./PaymentProviderVisaNet");
var DefaultText_1 = require("../../staticText/DefaultText");
var errorMessageHoc_1 = require("../../../../../../common/components/presentation/Error/errorMessageHoc");
var MinimalLoader_1 = require("../../../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var dimensions_1 = require("../../../../../../../../common/constants/dimensions");
var client_1 = require("@apollo/client");
var initPayment_1 = require("../../../graphql/mutations/initPayment");
var collectedFilters_1 = require("../../../../../../common/service/collectedFilters");
var useDealStatusAssertion_1 = require("../../../../../../common/react/useDealStatusAssertion");
var JourneyTypes_1 = require("../../../../../../../../common/enum/JourneyTypes");
var globalTypes_1 = require("../../../../../../__generated__/globalTypes");
var paymentService_1 = require("../../../../../common/service/paymentService");
var PaymentFailedMessage_1 = require("./errorMessages/PaymentFailedMessage");
var react_router_dom_1 = require("react-router-dom");
var errorHandler_1 = require("../../../../../common/service/errorHandler");
var OutOfStockPaymentError_1 = require("../../ErrorPages/OutOfStockPaymentError");
var InitPaymentError_1 = require("../../ErrorPages/InitPaymentError");
var PaymentVisaNet = function (_a) {
    var _b;
    var deal = _a.deal, componentHandleError = _a.componentHandleError;
    var _c, _d, _e, _f, _g;
    var style = PaymentVisaNetStyles_1.default();
    var _h = client_1.useMutation(initPayment_1.default.INITIALIZE_PAYMENT), initPayment = _h[0], loading = _h[1].loading;
    var parentNodeId = react_1.useState('wrapper:checkout:paymentProvider')[0];
    var _j = react_1.useState(null), paymentData = _j[0], setPaymentData = _j[1];
    var _k = react_1.useState(null), initError = _k[0], setInitError = _k[1];
    var _l = react_1.useState(false), softLocked = _l[0], setSoftLocked = _l[1];
    var paymentInfo = (_c = deal) === null || _c === void 0 ? void 0 : _c.paymentInfo;
    var lastTransaction = paymentService_1.paymentService.getLastTransaction(paymentInfo);
    var transactionError = (_e = (_d = lastTransaction) === null || _d === void 0 ? void 0 : _d.errorCode) === null || _e === void 0 ? void 0 : _e.length;
    var token = collectedFilters_1.default().filters.token;
    var location = react_router_dom_1.useLocation();
    var previousTransactions = (location.state || {}).previousTransactions;
    var noTransactionInitiated = ((_f = paymentInfo) === null || _f === void 0 ? void 0 : _f.length) === ((_g = previousTransactions) === null || _g === void 0 ? void 0 : _g.length);
    react_1.useEffect(function () {
        if (deal) {
            handlePayment();
        }
    }, [deal]);
    react_1.useEffect(function () {
        renderPaymentSection();
    }, [paymentData]);
    useDealStatusAssertion_1.default((_b = {},
        _b[JourneyTypes_1.JourneyTypes.RESERVE_ONLINE] = 3100,
        _b[JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP] = false,
        _b[JourneyTypes_1.JourneyTypes.ORDER_ONLINE] = false,
        _b));
    var handlePayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, initPayment({
                        variables: {
                            identifier: token,
                            paymentType: globalTypes_1.PaymentType.reservation_fee,
                        },
                    })
                        .then(function (initPaymentResponse) {
                        if (initPaymentResponse) {
                            var initPayment_2 = initPaymentResponse.data.initPayment;
                            setPaymentData({
                                formUrl: initPayment_2.url,
                                amount: initPayment_2.amount,
                                cardHolderEmail: initPayment_2.cardHolderEmail,
                                cardHolderName: initPayment_2.cardHolderName,
                                cardHolderLastName: initPayment_2.cardHolderLastName,
                                merchantId: initPayment_2.merchantId,
                                purchaseNumber: initPayment_2.purchaseNumber,
                                sessionToken: initPayment_2.sessionToken,
                            });
                        }
                    })
                        .catch(function (e) {
                        var _a;
                        var softLockedError = errorHandler_1.default.handleSoftLock(e);
                        setInitError(e);
                        setSoftLocked((_a = softLockedError) === null || _a === void 0 ? void 0 : _a.isStockLocked);
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var renderPaymentSection = react_1.useCallback(function () {
        if (loading) {
            return;
        }
        if (deal) {
            var merchantLogo = SubaruLogo_png_1.default;
            if (deal.brand === dimensions_1.dimensions.BRAND.BMW_DIS) {
                merchantLogo = BMWLogo_png_1.default;
            }
            return PaymentProviderVisaNet_1.default({
                parentNodeId: parentNodeId,
                merchantLogo: merchantLogo,
                paymentData: paymentData,
                className: style.visaNetForm,
            }).catch(componentHandleError);
        }
    }, [loading, paymentData]);
    if (initError) {
        if (softLocked) {
            return <OutOfStockPaymentError_1.default />;
        }
        return <InitPaymentError_1.default />;
    }
    if (loading || !paymentData) {
        return <MinimalLoader_1.default />;
    }
    return (<core_1.Box className={style.container}>
      {transactionError && !noTransactionInitiated ? (<PaymentFailedMessage_1.default style={style} paymentInfo={lastTransaction}/>) : (<DefaultText_1.default paymentData={paymentData} style={style}/>)}
      <core_1.Box data-test={parentNodeId} className={[style.paymentButtonWrapper, !loading && style.alignCenter].join(' ')}/>
    </core_1.Box>);
};
exports.default = errorMessageHoc_1.default(PaymentVisaNet);
